import authService from "./AuthService";
import {Types} from "./AuthConstants";
import API from "../common/utils/API";

const startNetwork   = () => ({ type: Types.NETWORK_START });
const stopNetwork    = () => ({ type: Types.NETWORK_STOP });
const networkError   = (error) => ({ type: Types.NETWORK_ERROR, error });
const networkSignIn  = (identity) => ({ type: Types.SIGN_IN, payload: identity });
const addUserRights = (accessLevel) => ({ type: Types.ADD_USER_RIGHTS, payload: accessLevel })
const networkSignOut = () => ({ type: Types.SIGN_OUT });

/**
 * Action for adding user rights to the redux-state.
 */
export function addUserPerms() {
    return async (dispatch) => {
        let newAccessLevel = {
            isAdmin: false,
            isSiteAdmin: false,
            isSupervisor: false,
            isDPAdmin: false,
            isDPEditor: false,
            isPricingAdmin: false,
            isTxDebugAdmin: false,
            isBillingAdmin: false,
        };
        const authToken = await authService.idUser();
        const tokenPayload = {
            auth_token: authToken.accessToken
        }
        return API.getUserMSDetails(tokenPayload, authToken.idToken)
            .then(res => {
                const groups = res.data.value;
                    // set the user's permissions
                groups.forEach(group => {
                    // determine if the user is a member
                    // of the veritas_admin group based
                    // on its ID
                    if (group.id === 'b17e5e36-19a4-415a-af73-1902010e6894') {
                        newAccessLevel.isAdmin = true;
                        newAccessLevel.isSiteAdmin = true;
                    }

                    // determine if the user is a member
                    // of the veritas_supervisor group based
                    // on its ID
                    if (group.id === '38552c87-fcb4-4ffe-b6fc-8b92e54c4b36') {
                        newAccessLevel.isAdmin = true;
                        newAccessLevel.isSupervisor = true;
                    }

                    // determine if the user is a member
                    // of the veritas_dpAdmin group based
                    // on its ID
                    if (group.id === '8e7496bd-049a-415f-824c-bde4e016cad7') {
                        newAccessLevel.isAdmin = true;
                        newAccessLevel.isDPAdmin = true;
                        newAccessLevel.isDPEditor = true;
                    }

                    // determine if the user is a member
                    // of the veritas_dpEditor group based
                    // on its ID
                    if (group.id === '62a9ab10-e31b-4c09-a43b-283bef7b0214') {
                        newAccessLevel.isDPEditor = true;
                    }

                    // determine if the user is a member
                    // of the marvel_tenant_pricing_admin group based
                    // on its ID
                    if (group.id === 'f3b48904-6ab4-434b-96cd-e959ffd025ab') {
                        newAccessLevel.isPricingAdmin = true;
                    }

                    // determine if the user is a member of the
                    // marvel_tx_debug_logs_admin group based on its ID.
                    if (group.id === '44cad77e-6845-48b1-9902-60fbe8168398') {
                        newAccessLevel.isTxDebugAdmin = true;
                    }
                    // determine if the user is a member of the
                    // marvel_billing_admin group based on its ID.
                    if (group.id === 'cdfb85c9-d36d-481f-bfe7-68d7a2952e2e') {
                        newAccessLevel.isBillingAdmin = true;
                    }
                });

                // Check if user has ANY role assigned
                if (!Object.values(newAccessLevel).some(Boolean)) return false;

                dispatch(startNetwork());
                dispatch(addUserRights(newAccessLevel));
                dispatch(stopNetwork());
                return true;
            }).catch(error => {
                console.error(error);
                throw error;
            })
    }
}

/**
 * Action for initiating an interactive sign-in.
 */
export function signIn() {
    return async (dispatch) => {
        try {
            dispatch(startNetwork());
            const identity = await authService.signIn();
            const hasRole = await dispatch(addUserPerms());
            if (hasRole) {
                dispatch(networkSignIn(identity));
            }
            dispatch(stopNetwork());
            // Return discriminated result so callers can distinguish no-role from success
            return hasRole === true
                ? { success: true }
                : { success: false, reason: 'no-role' };
        } catch (error) {
            dispatch(stopNetwork());
            dispatch(networkError(error));
            return { success: false, reason: 'error' };
        }
    };
}

/**
 * Action for initiating a sign-out.
 * This action is now updated to have a log-out only from Marvel
 * where as the commented call will sign the user out of their MS account.
 */
export function signOut() {
    return (dispatch) => {
        dispatch(startNetwork());
        dispatch(networkSignOut());
        dispatch(stopNetwork());
        // authService.signOut();
    };
}

const types = {
    Types,
}

export default types;
